import { Rating } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./FeedBack.css";
import useFullPageLoader from "common/UseFullPageLoader";
import { getFeedbackAPI } from "services/feedback";

const FeedBack = ({ userId }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [feedback, setFeedback] = useState([]);


  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await getFeedbackAPI({ userId });
      if (status === 200) {
        setFeedback(data?.data);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <div className="feedback_header">
      {loader}
      {
        <div className="feedback_content">

          <div className="wrap_rating">
            <b>{feedback?.rating} Stars</b>
            {feedback?.rating && <Rating className="rating_star" value={feedback?.rating}></Rating>}
          </div>

          <div className="feedback-text">
            <p>
              {
                feedback?.note
              }
            </p>
          </div>
        </div>}
    </div>
  );
};

export default FeedBack;
